export const scheduleFields = {
  code: {
    name: 'code',
    label: 'bookings.schedules.code.label',
    veeValidation: false,
    rules: [],
    help: 'bookings.schedules.code.help',
    showHelp: true,
    helpMode: 'tooltip',
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'bookings.schedules.status.label',
    help: 'bookings.schedules.status.help',
    showHelp: true,
    helpMode: 'tooltip',

    inputType: 'select',
    options: [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.inactive.label',
        value: 'inactive',
      },
    ],
    veeValidation: false,
    rules: [],
    defaultValue: 'active',
    valueToColor: [
      {
        value: 'active',
        color: 'border-0 text-white bg-success',
      },
      {
        value: 'inactive',
        color: 'border-0 text-white bg-danger',
      },
    ],
  },
  name: {
    name: 'name',
    label: 'bookings.schedules.name.label',
    help: 'bookings.schedules.name.help',
    showHelp: true,
    helpMode: 'tooltip',
    veeValidation: false,
    rules: [],
  },
  type: {
    fieldPath: 'type',
    fieldReadPath: 'type',
    name: 'type',
    label: 'bookings.schedules.type.label',
    help: 'bookings.schedules.type.help',
    showHelp: true,
    helpMode: 'tooltip',
    inputType: 'select',
    options: [
      {
        text: 'bookings.schedules.type.calendar.label',
        value: 'calendar',
      },
      {
        text: 'bookings.schedules.type.access_control.label',
        value: 'access_control',
        module: 'access_control',
      },
      {
        text: 'bookings.schedules.type.online_booking.label',
        value: 'online_booking',
        module: 'online_booking_v2',
      },
    ],
    veeValidation: false,
    rules: [],
    defaultValue: 'calendar',
  },
  online_booking_resources: {
    fieldPath: 'online_booking_resources',
    fieldReadPath: 'online_booking_resources',
    name: 'online_booking_resources',
    label: 'bookings.schedules.online_booking_resources.label',
    help: 'bookings.schedules.online_booking_resources.help',
    showHelp: true,
    helpMode: 'tooltip',
    inputType: 'entity-select',
    selectMultiple: true,
    selectClearable: true,
    selectValue: 'id',
    selectLabel: 'name',
    selectEntity: 'resource',
    displayConfigName: 'table',
    selectConfigName: ['filter'],
    filters: [],
    veeValidation: false,
    rules: [],
  },
  online_booking_resources_v2: {
    fieldPath: 'online_booking_resources_v2',
    fieldReadPath: 'online_booking_resources_v2',
    name: 'online_booking_resources_v2',
    label: 'bookings.schedules.online_booking_resources.label',
    help: 'bookings.schedules.online_booking_resources.help',
    showHelp: true,
    helpMode: 'tooltip',
    inputType: 'entity-select',
    selectMultiple: true,
    selectClearable: true,
    selectValue: 'id',
    selectLabel: 'name',
    selectEntity: 'resource',
    displayConfigName: 'table',
    selectConfigName: ['filter'],
    filters: [],
    veeValidation: false,
    rules: [],
  },
  calendar_resources: {
    fieldPath: 'calendar_resources',
    fieldReadPath: 'calendar_resources',
    name: 'calendar_resources',
    label: 'bookings.schedules.calendar_resources.label',
    help: 'bookings.schedules.calendar_resources.help',
    showHelp: true,
    helpMode: 'tooltip',
    inputType: 'entity-select',
    selectMultiple: true,
    selectClearable: true,
    selectValue: 'id',
    selectLabel: 'name',
    selectEntity: 'resource',
    displayConfigName: 'table',
    selectConfigName: ['filter'],
    filters: [],
    veeValidation: false,
    rules: [],
  },
};

export const onlineBookingSlotsFields = {
  slot_duration: {
    name: 'slot_duration',
    label: 'bookings.schedule.slot_duration_label',
    help: 'bookings.schedule.slot_duration_help',
    showHelp: true,
    helpMode: 'tooltip',
    veeValidation: false,
    rules: [],
    selectMultiple: false,
    options: [
      {
        text: 'global.durations.30min',
        short_text: 'bookings.slot.30min.short_label',
        value: 30,
      },
      {
        text: 'global.durations.60min',
        short_text: 'bookings.slot.60min.short_label',
        value: 60,
      },
      {
        text: 'global.durations.90min',
        short_text: 'bookings.slot.90min.short_label',
        value: 90,
      },
      {
        text: 'global.durations.120min',
        short_text: 'bookings.slot.120min.short_label',
        value: 120,
      },
      {
        text: 'global.durations.150min',
        short_text: 'bookings.slot.150min.short_label',
        value: 150,
      },
      {
        text: 'global.durations.180min',
        short_text: 'bookings.slot.180min.short_label',
        value: 180,
      },
      {
        text: 'global.durations.240min',
        short_text: 'bookings.slot.240min.short_label',
        value: 240,
      },
      {
        text: 'global.durations.300min',
        short_text: 'bookings.slot.300min.short_label',
        value: 300,
      },
      {
        text: 'global.durations.360min',
        short_text: 'bookings.slot.360min.short_label',
        value: 360,
      },
      {
        text: 'global.durations.420min',
        short_text: 'bookings.slot.420min.short_label',
        value: 420,
      },
      {
        text: 'global.durations.480min',
        short_text: 'bookings.slot.480min.short_label',
        value: 480,
      },
    ],
  },
  start_time: {
    name: 'start_time',
    label: 'bookings.schedule_season.start_time_label',
    veeValidation: false,
    rules: [],
    placeholder: '--:--',
    help: 'bookings.schedule_season.start_time_help',
    showHelp: true,
    helpMode: 'tooltip',
  },
  end_time: {
    name: 'end_time',
    label: 'bookings.schedule_season.end_time_label',
    veeValidation: false,
    rules: [],
    placeholder: '--:--',
    help: 'bookings.schedule_season.end_time_help',
    showHelp: true,
    helpMode: 'tooltip',
  },
  week_days_range: {
    name: 'week_days_range',
    label: 'bookings.schedule.week_days_range_label',
    veeValidation: false,
    selectMultiple: false,
    selectClearable: false,
    rules: [],
    help: 'bookings.schedule.week_days_range_help',
    showHelp: true,
    helpMode: 'tooltip',
    options: [
      {
        text: 'bookings.week_days_range.mon_sun',
        value: 'mon_sun',
      },
      {
        text: 'bookings.week_days_range.mon_fri',
        value: 'mon_fri',
      },
      {
        text: 'bookings.week_days_range.sat_sun',
        value: 'sat_sun',
      },
      {
        text: 'bookings.week_days_range.fri_sun',
        value: 'fri_sun',
      },
      {
        text: 'bookings.week_days_range.custom',
        value: 'custom',
      },
    ],
  },
  selected_week_days: {
    name: 'selected_week_days',
    label: 'bookings.schedule.selected_week_days_label',
    veeValidation: false,
    selectMultiple: false,
    rules: [],
    help: 'bookings.schedule.selected_week_days_help',
    showHelp: true,
    helpMode: 'tooltip',
    options: [
      {
        text: 'bookings.bookings.mon.label',
        value: 'mon',
      },
      {
        text: 'bookings.bookings.tue.label',
        value: 'tue',
      },
      {
        text: 'bookings.bookings.wed.label',
        value: 'wed',
      },
      {
        text: 'bookings.bookings.thu.label',
        value: 'thu',
      },
      {
        text: 'bookings.bookings.fri.label',
        value: 'fri',
      },
      {
        text: 'bookings.bookings.sat.label',
        value: 'sat',
      },
      {
        text: 'bookings.bookings.sun.label',
        value: 'sun',
      },
    ],
  },
  // slot_price_category_id: {
  //   fieldPath: 'slot_price_category_id',
  //   fieldReadPath: 'slot_price_category_id',
  //   name: 'slot_price_category_id',
  //   label: 'bookings.schedule.slot_price_category_label',
  //   selectLabel: 'name',
  //   selectEntity: 'slot-price-category',
  //   displayConfigName: 'table',
  //   selectConfigName: ['default'],
  //   selectMultiple: false,
  //   // selectValue: 'id',
  //   filters: [],
  //   help: 'bookings.schedule.slot_price_category_help',
  // },
  slot_price_category: {
    fieldPath: 'slot_price_category',
    fieldReadPath: 'slot_price_category',
    name: 'slot_price_category',
    label: 'bookings.schedule.slot_price_category_label',
    selectLabel: 'name',
    selectEntity: 'slot-price-category',
    displayConfigName: 'table',
    selectConfigName: ['default'],
    selectMultiple: false,
    // selectValue: 'id',
    filters: [],
    help: 'bookings.schedule.slot_price_category_help',
    showHelp: true,
    helpMode: 'tooltip',
  },
  day_type: {
    name: 'day_type',
    label: 'bookings.schedule.day_type_label',
    veeValidation: false,
    selectMultiple: false,
    rules: [],
    help: 'bookings.schedule.day_type_help',
    showHelp: true,
    helpMode: 'tooltip',
    options: [
      {
        text: 'bookings.schedules.day_type.business_day.label',
        value: 'business_day',
      },
      {
        text: 'bookings.schedules.day_type.bank_holiday.label',
        value: 'bank_holiday',
      },
      {
        text: 'bookings.schedules.day_type.holiday.label',
        value: 'holiday',
      },
    ],
  },
};

export const scheduleSeasonFields = {
  start_date: {
    name: 'start_date',
    label: 'bookings.schedule_season.start_date_label',
    veeValidation: false,
    rules: [],
    help: 'bookings.schedule_season.start_date_help',
    showHelp: true,
    helpMode: 'tooltip',
  },
  end_date: {
    name: 'end_date',
    label: 'bookings.schedule_season.end_date_label',
    veeValidation: false,
    rules: [],
    help: 'bookings.schedule_season.end_date_help',
    showHelp: true,
    helpMode: 'tooltip',
  },
  status: {
    fieldPath: 'status',
    fieldReadPath: 'status',
    name: 'status',
    label: 'bookings.schedule_season.status_label',
    help: 'bookings.schedule_season.status_help',
    showHelp: true,
    helpMode: 'tooltip',
    inputType: 'select',
    options: [
      {
        text: 'global.fields.status.active.label',
        value: 'active',
      },
      {
        text: 'global.fields.status.cancelled.label',
        value: 'cancelled',
      },
      {
        text: 'global.fields.status.blocked.label',
        value: 'blocked',
      },
    ],
    veeValidation: false,
    rules: [],
    defaultValue: 'active',
    valueToColor: [
      {
        value: 'active',
        color: 'border-0 text-white bg-success',
      },
      {
        value: 'cancelled',
        color: 'border-0 text-white bg-danger',
      },
      {
        value: 'blocked',
        color: 'border-0 text-white bg-warning',
      },
    ],
  },
  bank_holidays: {
    fieldPath: 'bank_holidays',
    fieldReadPath: 'bank_holidays',
    name: 'bank_holidays',
    label: 'bookings.schedule_season.bank_holidays_label',
    help: 'bookings.schedule_season.bank_holidays_help',
    showHelp: true,
    helpMode: 'tooltip',
    inputType: 'select',
    options: [
      {
        text: 'bookings.schedule_season.holidays.same_as_business_days',
        value: 'same_as_business_days',
      },
      {
        text: 'bookings.schedule_season.holidays.custom',
        value: 'custom',
      },
    ],
    veeValidation: false,
    rules: [],
    defaultValue: 'same_as_business_days',
  },
  school_holidays: {
    fieldPath: 'school_holidays',
    fieldReadPath: 'school_holidays',
    name: 'school_holidays',
    label: 'bookings.schedule_season.school_holidays_label',
    help: 'bookings.schedule_season.school_holidays_help',
    showHelp: true,
    helpMode: 'tooltip',
    inputType: 'select',
    options: [
      {
        text: 'bookings.schedule_season.holidays.same_as_business_days',
        value: 'same_as_business_days',
      },
      {
        text: 'bookings.schedule_season.holidays.same_as_bank_holidays',
        value: 'same_as_bank_holidays',
      },
      {
        text: 'bookings.schedule_season.holidays.custom',
        value: 'custom',
      },
    ],
    veeValidation: false,
    rules: [],
    defaultValue: 'same_as_business_days',
  },
  name: {
    name: 'name',
    label: 'bookings.schedule_season.name_label',
    veeValidation: false,
    rules: [],
    help: 'bookings.schedule_season.name_help',
    showHelp: true,
    helpMode: 'tooltip',
  },
};
